export * from "./controller";

export const HtmlTemplate = require("!html-loader!./index.html").default;
